export default "__VITE_ASSET__hQBD1jtg__"